import React from 'react'
import classNames from 'classnames'
import s from './CircledButtonWithLabel.less'
import T from '../i18n/T'
import SVGIcon from '../svg/SVGIcon'

export const LogoVariants = {
  smoothGreyBorder: 'logo-variant-smoothGreyBorder',
  sharpDarkGreyBorder: 'logo-variant-sharpDarkGreyBorder',
  sharpGreenBorder: 'logo-variant-sharpGreenBorder'
}

const CircledButtonWithLabel = ({
  logo,
  label,
  onClick,
  recenter,
  svgId,
  logoVariant = LogoVariants.smoothGreyBorder
}) => (
  <span className={s.container} onClick={onClick}>
    <span className={classNames(s.logo, logoVariant, recenter && s.recenter)}>
      {svgId ? <SVGIcon icon={svgId} /> : logo}
    </span>
    <span className={s.label}>
      <T id={label} />
    </span>
  </span>
)

export default CircledButtonWithLabel
